<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="table-body">
      <div style="overflow:hidden;margin: 0 0 8px 0;">
        <span style="float:left;">
          <el-button type="primary" @click="handleEdit({})" size="small"
            >新增</el-button
          >
        </span>
        <pagination
          :total="total"
          :page.sync="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          :page-sizes="[100, 200, 300, 400]"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table
        id="outTable"
        border
        :data="tableData"
        style="width: 100%"
        lazy
      >
        <el-table-column label="名称" prop="name" align="center">
        </el-table-column>
        <el-table-column label="变量类型" prop="varType" align="center">
           <template slot-scope="scope">
            <span>{{ dictMap["varType"][scope.row.varType] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="变量" prop="var" align="center">
        </el-table-column>
        <el-table-column label="数据来源" prop="source" align="center">
        </el-table-column>

        <el-table-column
          label="说明"
          prop="description"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="是否启用" prop="isUse" align="center">
          <template slot-scope="scope">
            <span>{{ dictMap["yes_or_no"][scope.row.isUse] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button type="text" size="mini" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        :page-sizes="[100, 200, 300, 400]"
        @pagination="loadData"
      />
    </div>
    <el-dialog :close-on-click-modal="false"  
      :title="dialogTitle"
      width="50%"
      :visible.sync="dialogVisible"
      class="note-dialog"
    >
      <el-row>
        <el-col>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="100px"
            size="small"
          >
            <el-form-item label="名称：" prop="name">
              <el-input v-model="form.name" clearable />
            </el-form-item>
            <el-form-item label="变量类型：" prop="varType">
              <el-select style="width: 100%;" clearable size="small" v-model="form.varType">
                <template v-for="(value, key) in dictData['varType']">
                  <el-option
                    :key="value.value"
                    :label="value.label"
                    :value="value.value"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="变量：" prop="var">
              <el-input v-model="form.var" clearable />
            </el-form-item>
            <el-form-item label="数据来源：">
              <el-input v-model="form.source" clearable />
            </el-form-item>
            <el-form-item label="说明：">
              <el-input v-model="form.description" clearable />
            </el-form-item>
            <el-form-item label="是否启用：">
              <el-radio-group v-model="form.isUse">
                <template v-for="(value, key) in dictData['yes_or_no']">
                  <el-radio :label="value.value" :key="value.value">
                    {{ value.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  listVar,
  addVar,
  editVar,
  deleteVar,
  addVarUse,
  editVarUse,
  getVar,
} from "@/api/sysSupport/variableManage"
import Template from "../../product/amazon/components/template.vue"

export default {
  name: "variableReference",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
      tableData: [],
      dialogVisible: false,
      form: {
        isUse: "1",
      },
      rules: {
        name: [{ required: true, message: "请选输入名称", trigger: "blur" }],
        varType: [{ required: true, message: "请输入变量", trigger: "blur" }],
        var: [{ required: true, message: "请输入变量", trigger: "blur" }],
      },
      dialogTitle: "新增变量",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      let params = {}
      listVar(params)
        .then((res) => {
          this.loading = false
          this.total = res.total
          this.tableData = res.rows
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    },
    handleEdit(row) {
      this.dialogVisible = true
      this.$refs["form"].resetFields()
      if (row.varId) {
        this.form = Object.assign({}, row)
        this.dialogTitle = "修改变量"
      } else {
        this.form = { isUse: "1" }
        this.dialogTitle = "新增变量"
      }
    },
    handleSave() {
      let _self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (_self.form.varId) {
            editVar(_self.form).then((response) => {
              if (response.code == "200") {
                _self.msgSuccess("修改成功！")
                _self.dialogVisible = false
                _self.loadData()
              } else {
                _self.msgError("修改失败！")
              }
            })
          } else {
            addVar(_self.form).then((response) => {
              if (response.code === 200) {
                _self.msgSuccess("新增成功！")
                _self.dialogVisible = false
                _self.loadData()
              } else {
                _self.msgError("新增失败！")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleDelete(row) {
      this.$confirm("确认删除变量？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteVar(row).then((response) => {
          if (response.code === 200) {
            this.msgSuccess("删除成功！")
            this.loadData()
          } else {
            this.msgError("删除失败！")
          }
        })
      })
    },
  },
}
</script>

<style scoped></style>
